import rehypeSanitize from 'rehype-sanitize'
import rehypeStringify from 'rehype-stringify'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import remarkTextr from 'remark-textr'
import { unified } from 'unified'

export interface MarkdownProps {
  [key: string]: string
}
/**
 * Helper to parse markdown string to html
 * @param data Object to replace strings in html (example: company_name: Company_Name)
 */
export default function useMarkdown(data: MarkdownProps) {
  const swapDataVariables = (input: string) => {
    const regex = /\{\{(.*?)\}\}/

    const matches = input.match(regex)
    return matches?.[1]
      ? input.replaceAll(new RegExp(regex, 'g'), data[matches[1]] || matches[1])
      : input
  }

  const parseToHTML = (markString: string) => {
    return unified()
      .use(remarkParse)
      .use(remarkRehype)
      .use(remarkTextr, { plugins: [swapDataVariables] })
      .use(rehypeSanitize)
      .use(rehypeStringify)
      .process(markString)
  }
  return { parseToHTML }
}
